// Контекст офлайн-статуса. Отделён от компонента-провайдера, чтобы OfflineProvider.tsx
// экспортировал только компонент (иначе ломается Fast Refresh).

import { createContext, useContext } from 'react';

export type OfflineState = {
  /** Есть ли сеть по мнению устройства. Точность — см. shared/hooks/useOnlineStatus. */
  readonly isOnline: boolean;
};

export const OfflineContext = createContext<OfflineState | null>(null);

export function useOfflineState(): OfflineState {
  const state = useContext(OfflineContext);

  if (!state) {
    throw new Error('useOfflineState вызван вне OfflineProvider');
  }

  return state;
}
